var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1607.8 51.5 437.5 492.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M1608.4 543V52.3l218.1 14 218-14V543z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E1E8ED",
    d: "M2043.9 53v489.4h-434.8V53l217.2 14h.2l217.4-14m1.3-1.5l-218.7 14.1-218.7-14.1v492.1h437.5l-.1-492.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M1608.4 543v-20.1c0-11.1 9-20.1 20.1-20.1h396c11.1 0 20.1 9 20.1 20.1V543h-436.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1E8ED",
    d: "M2024.5 503.5c10.8 0 19.4 8.8 19.4 19.4v19.4H1609.1v-19.4c0-10.8 8.8-19.4 19.4-19.4h396m0-1.2h-396c-11.4 0-20.7 9.3-20.7 20.7v20.7h437.5V523c-.1-11.5-9.4-20.7-20.8-20.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.2a333431c0f1986a82eebff46cd6dc53.svg";
export { ForwardRef as ReactComponent };